import useTranslation from 'next-translate/useTranslation'

import { NAMESPACE_S3_BUCKET } from '@/res/namespaces'

const Advantages: React.FC = () => {
  const { t } = useTranslation(NAMESPACE_S3_BUCKET)

  return (
    <>
      <div className="container advantages pb-16 lg:pb-20">
        <h5 className="text-[#242F3C] font-semibold text-xl sm:text-[28px] lg:text-4xl mb-2.5 lg:mb-5">
          {t('advantages')}
        </h5>
        <div className="grid grid-flow-row grid-flow-cols-1 grid-flow-rows-3 md:grid-flow-col md:grid-cols-3 md:grid-flow-rows-1 gap-5">
          <div className="card p-2 pb-[15px] rounded-2xl">
            <div className="w-full h-[120px] bg-[#428BF9] rounded-2xl p-5 ">
              <h6 className="text-white font-semibold text-tiny md:text-sm lg:text-md ">
                {t('adv1')}
              </h6>
            </div>
            <p className="text-[#7B8794] text-tiny lg:text-sm lg:leading-[24px] m-2.5 lg:m-5 md:line-clamp-4 xl:line-clamp-none">
              {t('adv1_des')}
            </p>
          </div>
          <div className="card p-2 pb-[15px]  rounded-2xl">
            <div className="w-full h-[120px] bg-[#428BF9] rounded-2xl p-5 ">
              <h6 className="text-white font-semibold md:text-sm lg:text-md">
                {t('adv2')}
              </h6>
            </div>
            <p className="text-[#7B8794] text-tiny lg:text-sm lg:leading-[24px] m-2.5 lg:m-5 md:line-clamp-4 xl:line-clamp-none">
              {t('adv2_des')}
            </p>
          </div>
          <div className="card p-2 pb-[15px] rounded-2xl">
            <div className="w-full h-[120px] bg-[#428BF9] rounded-2xl p-5 ">
              <h6 className="text-white font-semibold md:text-sm lg:text-md">
                {t('adv3')}
              </h6>
            </div>
            <p className="text-[#7B8794] text-tiny lg:text-sm lg:leading-[24px] m-2.5 lg:m-5 md:line-clamp-4 xl:line-clamp-none">
              {t('adv3_des')}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Advantages
